<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Certificate Issue</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Certificate
                Issue
            </div>
            <!-- //breadcrumbs -->
            <!-- Role tit -->
            <div class="sub_tit">Role</div>
            <!-- //Role tit -->
            <!-- detail_Role -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>User Role</th>
                        <td>
                            <select class="slt_white input-58">
                                <option>KOREA, REPUBLIC OF</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //detail_Role -->
            <!-- Basic tit -->
            <div class="sub_tit mt40">Basic</div>
            <!-- //Basic tit -->
            <!--Basic -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Name</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    value=" "
                                />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                        <th>English Name</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    value=" "
                                />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            ESN/IMEI Writing P/W
                            <span class="ico_sech_sm">search아이콘</span>
                        </th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                        <th>ESN/IMEI Confirm P/W</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Country</th>
                        <td colspan="3">
                            <select class="slt_white input-58">
                                <option>KOREA, REPUBLIC OF</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>Cell Phone Number</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                        <th>Office Phone Number</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Fax Number</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                        <th>Email</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //Basic -->
            <!-- Additional tit -->
            <div class="sub_tit mt40">Additional</div>
            <!-- //Additional tit -->
            <!-- Additional -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Center Name</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Center Address</th>
                        <td>
                            <ul>
                                <li class="fL">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w220p"
                                            placeholder="Zip Code"
                                        />
                                        <i class="clearable_clear">삭제버튼</i>
                                    </span>
                                </li>
                                <li>
                                    <span class="clearable w100-230 ml10">
                                        <input type="text" class="text_input" placeholder="City" />
                                        <i class="clearable_clear">삭제버튼</i>
                                    </span>
                                </li>
                                <li class="mt5">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" placeholder />
                                        <i class="clearable_clear">삭제버튼</i>
                                    </span>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Contact Person</th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100" placeholder />
                                <i class="clearable_clear">삭제버튼</i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //Additional -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
    created() {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/home/HHPHome.vue